(async () => {
  if (!customElements.get('slider-banner')) {
    const { default: Swiper, A11y, Autoplay, Navigation, EffectFade } = await import('swiper');

    Swiper.use([A11y, Autoplay, Navigation, EffectFade]);

    class SliderBanner extends HTMLElement {
      constructor() {
        super();
        this.swiper = this.querySelector('[data-swiper]');

        // Redefine self to be able to call it in swiper instance
        const self = this;

        // Stop when the swiper is not found
        if (!this.swiper) {
          return;
        }

        // Default to improve user experience
        this.swiperOptions = {
          threshold: 10,
        };

        // Check if we have extra options on the HTML
        if (this.swiper.dataset.options) {
          const options = JSON.parse(this.swiper.dataset.options);

          if (options) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...options,
            };
          }
        }

        // Call swiper with selected swiper element and options
        this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

        // Common variables
        const defineCommonVars = (swiperInst) => {
          // active
          this.activeSlide = swiperInst.slides[swiperInst.activeIndex];
          this.activeSlideInner = this.activeSlide.querySelector('.slider__slide-inner');
          this.activeSlideContent = this.activeSlide.querySelector('.slider__content');

          //prev
          this.prevSlide = swiperInst.slides[swiperInst.previousIndex];
          this.prevSlideInner = this.prevSlide.querySelector('.slider__slide-inner');
        };

        // Common class logic
        const handleClassChange = (direction) => {
          if (self.activeSlideContent) {
            self.activeSlideContent.style.opacity = 0;
          }

          // Removal of the default classes
          self.activeSlideInner.classList.remove(
            'prev-forward',
            'prev-backward',
            'active-backward',
            'active-forward'
          );
          self.prevSlideInner.classList.remove(
            'prev-forward',
            'prev-backward',
            'active-backward',
            'active-forward'
          );

          // Addiction of the new class based on the direction
          self.activeSlideInner.classList.add(`active-${direction}`);
          self.prevSlideInner.classList.add(`prev-${direction}`);
        };

        // Disable arrows while animation is playing
        const handleSwiperNav = (swiperInst) => {
          swiperInst.navigation.disable();
          setTimeout(() => {
            swiperInst.navigation.enable();
          }, 1500);
        };

        // Animation logic. Do not show animation in editor
        if (!Shopify.designMode) {
          // Common logic || slideChange
          this.swiperInstance.on('slideChange', function () {
            // Passing swiper instance to define common variables
            defineCommonVars(this);
            handleSwiperNav(this);
          });

          // Animation logic on click to the next slide || slideNextTransitionStart
          this.swiperInstance.on('slideNextTransitionStart', function () {
            handleClassChange('forward');
          });

          // Animation logic on click to the prev slide || slidePrevTransitionStart
          this.swiperInstance.on('slidePrevTransitionStart', function () {
            handleClassChange('backward');

            // Hack to trick swiper
            self.prevSlide.style.opacity = 1;
            setTimeout(() => {
              self.prevSlide.style.opacity = 0;
            }, 1500);
          });
        }

        /**
         * Listen to extra events when in Shopify editor
         */
        if (Shopify.designMode) {
          // Update the swiper when the section event is triggered
          window.addEventListener('shopify:section:load', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
          });

          // When on block select go to the slide in front-end
          window.addEventListener('shopify:block:select', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            this.handleBlockSelect(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener('shopify:block:deselect', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            this.handleBlockSelect(event);
          });
        }
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleBlockSelect(event) {
        // Check if the slide index is set
        if (!('swiperSlideIndex' in event.target.dataset)) {
          return;
        }

        // Set the slide index based on loop settings or not
        let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
        if (this.swiperOptions.loop) {
          swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
        }

        // Slide to slide based on the data attribute from the target
        const sliderToUpdate = event.target.closest('[data-swiper]');
        sliderToUpdate.swiper.slideTo(swipeToSlideIndex, 1000);
      }
    }

    window.SliderBanner = SliderBanner;

    customElements.define('slider-banner', SliderBanner);
  }
})();
